import React from 'react';
import { Link } from 'react-router-dom';

const LAST_UPDATED = '6 June 2026'; // update when needed

const SupportPage: React.FC = () => (
  <main className="container">
    <header style={{ paddingTop: '0', paddingBottom: '0.5rem' }}>
      <Link to="/" className="back-home-link" aria-label="Back to home">← Back to home</Link>
    </header>

    <article className="section" style={{ background: '#fff' }}>
      <h1>Sparki Support</h1>
      <p><em>Last updated: {LAST_UPDATED}</em></p>

      <p>
        Need help with Sparki? This page explains how to contact us and where to get support
        for bookings, garages, quotes, invoices, account access, and account deletion.
      </p>

      <h2>Contact us</h2>
      <p>
        For support, email us at{' '}
        <a className="footer-link" href="mailto:support@sparkiapp.com?subject=Sparki%20Support%20Request">
          support@sparkiapp.com
        </a>.
      </p>
      <p>
        We aim to respond within 2 business days. Please include enough information for us to
        understand your issue and identify your account where needed.
      </p>

      <h2>What to include</h2>
      <p>To help us look into your request, please include:</p>
      <ul>
        <li>The email address registered to your Sparki account.</li>
        <li>Whether you are using Sparki as a customer, garage, or both.</li>
        <li>A short description of the issue.</li>
        <li>Any relevant booking, quote, invoice, or garage details.</li>
        <li>Screenshots of the issue, if helpful.</li>
      </ul>

      <h2>Booking and garage support</h2>
      <p>
        If your question is about a specific MOT, service, repair, quote, invoice, or vehicle update,
        you can also contact the garage directly through Sparki messages where available.
      </p>

      <h2>Account access</h2>
      <p>
        If you are having trouble signing in, checking your bookings, or accessing your account,
        email us from the email address linked to your Sparki account where possible.
      </p>

      <h2>Account deletion</h2>
      <p>
        You can request deletion of your Sparki account and associated personal data at any time.
        For details, visit our{' '}
        <Link className="footer-link" to="/delete-account">
          account deletion page
        </Link>.
      </p>

      <h2>Privacy</h2>
      <p>
        For information about how Sparki handles personal data, please read our{' '}
        <Link className="footer-link" to="/privacy">
          Privacy Policy
        </Link>.
      </p>
    </article>
  </main>
);

export default SupportPage;